const NewBadge = () => {
  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-200 text-green-800 border-2 border-white">
      New
    </span>
  );
};

export default NewBadge;
